import { GetterTree } from 'vuex'
import { RootState, DiscountOp } from './types'
import config from '@/config'
import { DeliveryPrice, PaymentGateway, DeliveryOption, PaymentGatewayMap, Discount as PbDiscount } from 'proto/eshop/Basket_pb'

export const getters: GetterTree<RootState, RootState> = {
	productById: state => (id: string) => state.products
		.find(product => product.id === id),

	// private
	summaryPrice100: (state) => {
		const dopt = new DiscountOp(state.discount)
		var sum: number = 0
		for (let p of state.products) {
			sum += dopt.isDiscount
				? dopt.computeProductPriceCount(p)
				: p.price100 * Math.max(p.count, 0)
		}
		return sum
	},

	deliveryPrice100: (state) => {
		if (!config.deliveryEnabled) return 0
		const dopt = new DiscountOp(state.discount)
		return dopt.isDiscount
			? dopt.computeDeliveryPrice(state.userInfo.deliveryPrice100)
			: state.userInfo.deliveryPrice100
	},

	totalPrice100: (state, getters) => {
		const dopt = new DiscountOp(state.discount)
		if (!dopt.isDiscount) {
			return getters.summaryPrice100 + getters.deliveryPrice100
		}

		switch (state.discount.target) {
			case PbDiscount.Target.NONE:
				return getters.summaryPrice100 + getters.deliveryPrice100

			case PbDiscount.Target.WHOLE_BASKET:
				return dopt.apply(getters.summaryPrice100 + getters.deliveryPrice100)

			case PbDiscount.Target.PRODUCTS_ONLY:
				return dopt.apply(getters.summaryPrice100) + getters.deliveryPrice100

			case PbDiscount.Target.DELIVERY_ONLY:
				return getters.summaryPrice100 + getters.deliveryPrice100 // скидка уже применена

			case PbDiscount.Target.PRODUCTS_LIST:
				return getters.summaryPrice100 + getters.deliveryPrice100 // скидка уже применена

			default:
				throw Error('unknown discount target: ' + state.discount.target)
		}
	},

	vatPrice100: (state, getters) => {
		return config.vat > 0
			? getters.totalPrice100 / (1 + config.vat) * config.vat
			: 0
	},

	minDeliveryPrice100: () => (delivery: DeliveryOption.AsObject) => {
		if (!delivery) return 0
		let result: number | null = null
		delivery.pricesList.forEach(option => {
			result = result === null ? option.price100 : Math.min(result, option.price100)
		})
		return result === null ? 0 : result
	},

	availableDeliveryOptions: (state, getters) => (payment: ValueOf<PaymentGatewayMap>) => {
		if (!config.deliveryEnabled) return [] // пустой список когда отключен выбор службы доставки
		const deliveryOptions = config.deliveryOptionsList
		const result: Array<DeliveryOption.AsObject> = []
		deliveryOptions.forEach(delivery => {
			const pricesList: Array<DeliveryPrice.AsObject> = []
			delivery.pricesList.forEach(option => {
				const paymentGateway = (
					option.paymentGateway === PaymentGateway.NO_PAYMENT_GATEWAY ||
					option.paymentGateway === payment)
				const total = getters.summaryPrice100 >= option.total
				const productId = Boolean(!option.productId || getters.productById(option.productId))
				if (paymentGateway && total && productId) pricesList.push(option)
			})
			const availableDelivery = Object.assign({}, delivery)
			availableDelivery.pricesList = pricesList
			if (pricesList.length) result.push(availableDelivery)
		})
		return result
	},

	products: (state) => {
		return state.products
	},

	discount: (state) => {
		return state.discount
	},

	promoCode: (state) => {
		return state.discount.code
	},

	isDiscount: (state) => {
		return state.discount.code !== ''
	},
}
